module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAABYCAYAAAAwYU2LAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACuSURBVHgBlVQBDsQgCAO3//9Ye2JkgQA7t8QoUkpLzIjmB4Bl531YQduHS3YJSC80uAWlsLXunbksQVMCDVozMEfgMrEmyHFsDhYyHAj4G0FL/eRy2Joja+6/Ak6ncyinhgWh9Xhz1QfaQObtSNDnGlozyuCBjb1wRoB3AleDsqmDjbKPykFpoSsMqYVUgWPrFpYTILVNZR/H5prCNg1Oxys1Pkz0ga2XMf8w6/IHxtxxqo9U5/4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/centerImg.png
// module id = zZbu
// module chunks = 0